<script setup lang="ts">
import { useWindowFocus } from '@vueuse/core'

import { useFetchGeneral } from '~/api/service/general/index.service'
import DashboardAccounts from '~/components/@pages/home/DashboardAccounts.vue'
import DashboardBalance from '~/components/@pages/home/DashboardBalance.vue'
import DashboardBlock from '~/components/@pages/home/DashboardBlock.vue'
import DashboardBlockList from '~/components/@pages/home/DashboardBlockList.vue'
import DashboardBurntFee from '~/components/@pages/home/DashboardBurntFee.vue'
import DashboardDailyAccountCreated from '~/components/@pages/home/DashboardDailyAccountCreated.vue'
import DashboardEtcTransactions from '~/components/@pages/home/DashboardEtcTransactions.vue'
import DashboardGasInfo from '~/components/@pages/home/DashboardGasInfo.vue'
import DashboardTokenTransfer from '~/components/@pages/home/DashboardTokenTransfer.vue'
import DashboardTransactions from '~/components/@pages/home/DashboardTransactions.vue'
import DashboardTxnTable from '~/components/@pages/home/DashboardTxnList.vue'
import HomeSearchArea from '~/components/@pages/home/HomeSearchArea.vue'
import MobileDashboardBlockList from '~/components/@pages/home/mobile/MobileDashboardBlockList.vue'
import { HOME_REFETCH_PARAMS } from '~/constants/general.const'
import { generalParamType } from '~/types/general.type'
import { getBreadCrumb } from '~/utils/breadCrumbList'
import LatestNFTMintArea from '~/components/@pages/home/LatestNFTMintArea.vue'

// 이거 차트 로드할때 필요함...
await import('echarts')

const { refetch: blockRefetch } = useFetchGeneral([ generalParamType.BLOCK ])
const { refetch } = useFetchGeneral(HOME_REFETCH_PARAMS)

const refetchOnlyBlock = ref(false)

const windowFocused = useWindowFocus()

let intervalId: NodeJS.Timeout

watchEffect(() => {
  if (windowFocused.value) {
    intervalId = setInterval(async () => {
      refetchOnlyBlock.value = !refetchOnlyBlock.value
      refetchOnlyBlock.value ? await blockRefetch() : await refetch()
    }, 2000)
  } else {
    clearInterval(intervalId)
  }
})

onBeforeUnmount(() => {
  clearInterval(intervalId)
})

useHead(getBreadCrumb())
</script>

<template>
  <div class="home-container">
    <LatestNFTMintArea />
    <HomeSearchArea class="search-area" />
    <div class="dashboard-cont">
      <ClientOnly>
        <DashboardBlock />
        <DashboardTransactions />
        <DashboardAccounts />

        <DashboardGasInfo class="hide-mobile" />
        <DashboardEtcTransactions class="hide-mobile" />
        <DashboardDailyAccountCreated class="hide-mobile" />

        <DashboardBurntFee class="hide-mobile" />
        <DashboardTokenTransfer class="hide-laptop" />
        <DashboardBalance />
      </ClientOnly>
    </div>
    <div class="table-cont">
      <DashboardBlockList class="block-list" />
      <MobileDashboardBlockList class="block-list mobile" />
      <DashboardTxnTable />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.home-container {
  @apply flex flex-col gap-y-16 laptop:gap-y-8 mobile:gap-y-4;

  .dashboard-cont {
    @apply grid grid-cols-3 gap-6;

    @include md {
      @apply grid-cols-2;
    }

    @include sm {
      @apply grid-cols-1 gap-y-2;
    }

    & .hide-laptop {
      @include md {
        display: none;
      }
    }

    & .hide-mobile {
      @include sm {
        display: none;
      }
    }
  }

  .table-cont {
    @apply grid grid-cols-2 mt-16 gap-6;

    @include md {
      @apply grid-cols-1 gap-16;
    }

    .block-list {
      @include sm {
        display: none;
      }

      &.mobile {
        display: none;

        @include sm {
          display: block;
        }
      }
    }
  }

  .skeleton-image {
    width: 100%;
    height: 940px;
  }

  .table {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 700px;
    font-size: 50px;
  }
}
</style>